import * as React from 'react';
import { connect } from 'react-redux';
import { handleNextStep, setQuoteData } from '../../../../actions/salesActions';
import { getQuoteIncidentTypesByRiskItemType } from '../../../../actions/claimSubmitActions';
import KPClaimList from '../../../BaseTemplate/SSPCustomComponentLibrary/KPClaimList/KPClaimList';
import { ILossType, IClaimListItem } from '../../../../interfaces/KPClaimList/KPClaimListInterfaces';
import { IDropdownData } from '../../../../interfaces/KPDropdown/KPDropdownInterfaces';
import { BUILDING_CLAIM_TYPE_ID, CONTENT_CLAIM_TYPE_ID, PRODUCT_HOME_CONTENT } from '../../../../constants/constants';
import './ClaimsCapture.css';
import { postToController } from '../../../../actions/apiActions';

class ClaimsCapture extends React.PureComponent<any, any> {
    claimListComponent: React.RefObject<KPClaimList>;

    constructor(props: any) {
        super(props);

        this.state = {
            claimCount: this.props.sales.claimsCount ?? 1,
            claimsHistory: this.props.sales.claimsHistory ?? [],
            lossTypes: [],
            lossItems: [],
            submitted: false,
            nextDisabled: false
        };

        this.claimListComponent = React.createRef();

        this.checkSubmit = this.checkSubmit.bind(this);
        this.handleNextStep = this.handleNextStep.bind(this);
    }

    async componentDidMount() {
        let lossTypes = await this.getLossTypes();
        let lossItems = await this.getLossItems(lossTypes);
        this.setState({ lossTypes, lossItems });

        if (this.claimListComponent?.current != null) {
            this.claimListComponent.current.setList(lossItems);
            this.claimListComponent.current.setLossTypes(lossTypes);
        }
    }

    checkSubmit() {
        this.claimListComponent?.current?.validate(true);
    }

    async getLossItems(lossTypes: ILossType[]): Promise<IClaimListItem[]> {
        let dataSet: IClaimListItem[] = [];
        let filterValue = BUILDING_CLAIM_TYPE_ID;
        if (this.props.sales.addProduct === PRODUCT_HOME_CONTENT) {
            filterValue = CONTENT_CLAIM_TYPE_ID;
        }
        await postToController(this.props.dispatch, 'GetAddressClaimsByAddressId', JSON.stringify({ Parameter: this.props.sales.addressId })).then(async (response) => {
            
            response.filter(x => x.riskItemType == filterValue).forEach((item, index) => {
                let addressLoss = lossTypes.filter(x => x.id === item.incidentTypeId.toString())[0]
                dataSet.push({
                    index: index + 1,
                    id: (index + 1).toString(),
                    date: new Date(item.dateOfLoss),
                    lossType: { id: addressLoss.id, description: addressLoss.description, productName: "", image: "" } as IDropdownData,
                    value: item.claimValue,
                    isExisting: true,
                    claimType: filterValue,
                    currentPremises: item.currentPremises,
                });
            });
        });
        for (let i = dataSet.length; i < Math.max(this.state.claimCount, this.state.claimsHistory.length); i++) {
            let claim = (i < this.state.claimsHistory.length) ? this.state.claimsHistory[i] : null;
            if (claim !== null) {
                if (claim.claimType === filterValue) {
                    let lossType = (claim !== null)
                        ? { id: claim.lossType, description: lossTypes.filter(x => x.id === claim.lossType)[0]?.description, productName: "", image: "" } as IDropdownData
                        : null;
                    dataSet.push({
                        index: i + 1,
                        id: (i + 1).toString(),
                        date: claim?.date,
                        lossType: lossType,
                        value: claim?.value,
                        isExisting: false,
                        claimType: filterValue,
                        currentPremises: false,
                    });
                }
            }
            else {
                dataSet.push({
                    index: i + 1,
                    id: (i + 1).toString(),
                    date: null,
                    lossType: null,
                    value: null,
                    isExisting: false,
                    claimType: filterValue,
                    currentPremises: false,
                });
            }
        }
        return dataSet;
    }

    async getLossTypes(): Promise<ILossType[]> {
        let lossTypes: ILossType[] = [];
        let riskItemType = BUILDING_CLAIM_TYPE_ID;
        if (this.props.sales.addProduct === PRODUCT_HOME_CONTENT) {
            riskItemType = CONTENT_CLAIM_TYPE_ID;
        }
        let items = await this.props.dispatchAction(getQuoteIncidentTypesByRiskItemType(riskItemType));
        items.forEach(item => {
            lossTypes.push({
                id: item.id.toString(),
                description: item.description
            });
        });
        return lossTypes;
    }

    async handleNextStep() {
        if (!this.state.nextDisabled) {
            if (this.claimListComponent?.current !== null) {
                if (this.claimListComponent.current.validate(true)) {
                    let items: any = [];
                    this.claimListComponent.current.getList().forEach(item => {
                        items.push({
                            id: item.id,
                            date: item.date,
                            lossType: item.lossType?.id,
                            value: item.value,
                            isExisting: item.isExisting,
                            claimType: item.claimType,
                            currentPremises: item.currentPremises
                        });
                    });
                    this.props.dispatchAction(setQuoteData({ claimsHistory: items }));
                    this.props.dispatchAction(handleNextStep());
                }
            }
        }
    }

    public render() {
        let claimAddType = BUILDING_CLAIM_TYPE_ID
        if (this.props.sales.addProduct === PRODUCT_HOME_CONTENT) {
            claimAddType = CONTENT_CLAIM_TYPE_ID;
        }
        return (
            <div className="container ssp-claim-capture">
                {this.props.sales.addProduct === PRODUCT_HOME_CONTENT &&
                    <div className="step-instructions text-center mt-4">
                        In the last 3 years, have you had any home contents claims?
                    </div> || <div className="step-instructions text-center mt-4">
                        In the last 3 years, have you had any building claims?
                    </div>
                }

                <div className="row mt-4">
                    <div className="col-12 noma nopa text-left">
                        <KPClaimList
                            ref={this.claimListComponent}
                            initialCount={this.state.claimCount}
                            items={this.state.lossItems}
                            currencySymbol={(this.props.profile.currencySymbol + " ")}
                            claimType={claimAddType}
                        />
                    </div>
                </div>

                <div className="row mt-4">
                    <div className="col-12 justify-content-center">
                        <button type="button" className="btn btn-solid-red btnNavigate" disabled={this.state.nextDisabled} onClick={this.handleNextStep}>Next</button>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        sales: state.sales,
        profile: state.profile
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchAction: (e) => dispatch(e)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ClaimsCapture);